export default "__VITE_ASSET__Dw3Wihed__"